import Breadcrumb from '@/components/feature/Breadcrumb';
import type { Article } from '@/types/content';

export default function ArticleHeader({ article }: { article: Article }) {
  return (
    <header className="bg-background-100">
      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-8 md:py-14">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '专题分类', path: '/topics' },
            { label: article.categoryName, path: `/topics?cat=${article.categoryId}` },
            { label: article.title },
          ]}
        />
        <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
          <i className="ri-folder-open-line" />
          {article.categoryName}
        </span>
        <h1 className="font-heading mt-4 text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
          {article.title}
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{article.excerpt}</p>
        <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500 md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-3-line" />
            {article.author}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line" />
            {article.date}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line" />
            {article.readTime}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-primary-500" />
            热度 {article.heat}
          </span>
        </div>
      </div>
    </header>
  );
}